import * as types from 'constants/actionTypes';
import initialState from './initialState';

export default function dashboardReducer(state = initialState.dashboard, action) {
    switch (action.type) {

        case types.DASHBOARD_FAIL: {
            return {
                ...state,
                error: action.error
            };
        }

        case types.DB_ORDERS_GOT: {
            return {
                ...state,
                orders: action.data
            };
        }

        case types.DB_CASHDRAWER_GOT: {
            return {
                ...state,
                cashDrawer: action.data
            };
        }

        case types.DB_SALES_GOT: {
            return {
                ...state,
                sales: action.data
            };
        }

        case types.DB_TOP_PRODUCTS_SALES_GOT: {
            return {
                ...state,
                topProducts: action.data
            };
        }

        case types.DB_TOP_MEMBERS_GOT: {
            return {
                ...state,
                topMembers: action.data
            };
        }

        case types.DB_TOP_SELLERS_GOT: {
            return {
                ...state,
                topSellers: action.data
            };
        }

        case types.DB_TIMESHEET_GOT: {
            return {
                ...state,
                timesheet: action.data
            };
        }

        case types.DB_PURCHASE_ORDER_GOT: {
            return {
                ...state,
                purchaseOrders: action.data
            };
        }

        case types.DB_INVENTORY_GOT: {
            return {
                ...state,
                inventory: action.data
            };
        }

        case types.DB_CAMPAIGN_GOT: {
            return {
                ...state,
                campaings: action.data
            };
        }

        default:
            return state;
    }

}